import React, {  } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import { ddados } from "../solicitarDocumento.ddados";
import autobind from "react-autobind";
import RedeSIMForm from "../../redeSIM.form";
import solicitarDocumentoSelector from "../store/solicitarDocumento.selectors";
import solicitarDocumentoActions from "../store/solicitarDocumento.actions";
import PesquisaDocumentoModal from "./pesquisaDocumento.modal";
import SolicitarDocumentoGridPesquisa from "./solicitarDocumento.gridPesquisa";
import GridSolicitacaoDocumento from "./solicitarDocumento.form";
import SolicitarDocumentoResultado from "./resultadoSolicitarDocumento.modal";


class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  verifyCallback(response) {
    this.props.solicitarDocumentoActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.solicitarDocumentoActions.setTokenRecaptcha("");
  }

  onSubmit(values) {
    this.props.solicitarDocumentoActions.pesquisarSolicitacaoDocumento(values);
  }

  onSearch(values) {
    this.props.solicitarDocumentoActions.toggleModalPesquisaDocumento();
  }

  componentDidMount(){
    this.props.solicitarDocumentoActions.resetSolicitacaoDocumentoPost();
    this.props.solicitarDocumentoActions.verificaDocumentoLiberadoSolicitacao();
  }

  render() {
    const { solicitarDocumento } = this.props.solicitarDocumentoSelector;
    const gridPesquisaDocumento = solicitarDocumento.GridSolicitarDocumentoPesquisa?.length > 0;
    const gridSolicitacaoDocumento = (!!solicitarDocumento.SolicitacaoDocumentoPost?.Protocolo
      && !gridPesquisaDocumento);
    const redeSimForm = (!gridPesquisaDocumento && !gridSolicitacaoDocumento);

    return (
      <>
        <SolicitarDocumentoResultado show={solicitarDocumento.ResultadoDocumentoModalToggle} />

        <PesquisaDocumentoModal show={solicitarDocumento.PesquisaDocumentoModalToggle} />

        { gridSolicitacaoDocumento && (
          <GridSolicitacaoDocumento />
        )}

        { gridPesquisaDocumento && (
          <SolicitarDocumentoGridPesquisa />
        )}

        { redeSimForm && (
          <RedeSIMForm
            title={ddados.Titulo}
            verifyCallback={this.verifyCallback}
            expiredCallback={this.expiredCallback}
            onSubmit={this.onSubmit}
            onSearch={this.onSearch}
            isView
          />
        )}
      </>
    );
  }
}

export default connect({
  actions: {
    solicitarDocumentoActions
  },
  selectors: {
    solicitarDocumentoSelector
  }
})(Container);

